import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { firestore } from '../contexts/FirebaseContext';
import { getBalanceTypeUser, getSaldoType, getWalletUser } from '../utils/formatWallet';
// import useAuthUsers from './useAuthUsers';
import useWallet from './useWallet';

// name event
const actionsWallet = {
  addWallet: 'ADD',
  substractWallet: 'SUBSTRACT'
};

function useWalletEvents() {
  const [loadingWalletEvent, setLoadingWalletEvent] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { recargar, cobrar } = useWallet();

  const handleWalletEvent = async ({
    nameEvent,
    ownerUserID,
    category_service_id,
    amount,
    message,
    reason,
    payment_method,
    payment_source,

    extraData = {},

    rerport_id,
    reporteAction,
    // para que la funcion de registrar reporte se ejecute

    // array de funciones que se ejecutan si toda va bien
    successFuncts,
    successFunctsParams,
    // si deseamos que el snackbar se muestre
    successSnackbar
  }) => {
    setLoadingWalletEvent(true);
    // El nido definitivo
    // kintaro335-sp
    // too bad

    if (amount > 0) {
      const prevWalletUser = await getWalletUser(ownerUserID);

      if (nameEvent === 'ADD') {
        recargar(amount, ownerUserID, category_service_id)
          .then(async () => {
            const actualWalletUser = await getWalletUser(ownerUserID);
            await firestore.collection('transactionUsers').add({
              amount,
              increase: true,
              user_id: ownerUserID,
              categoryService: category_service_id,
              previousBalance: prevWalletUser[getSaldoType(category_service_id)],
              laterBalance: actualWalletUser[getSaldoType(category_service_id)],
              payment_method,
              payment_source,
              message: message || 'Sin mensaje',
              reason,
              ...extraData,
              rerport_id: rerport_id || '-',
              created_at: new Date(),
              updated_at: new Date()
            });

            if (reporteAction)
              await firestore
                .collection('payment_reports')
                .doc(rerport_id)
                .update({
                  status: 'APLICADO',
                  accept_message: message || 'Sin mensaje',
                  authorized_at: new Date(),
                  updated_at: new Date()
                });

            const res = await firestore.collection('walletEvents').add({
              date: new Date(),
              initWallet: false,
              user_id: ownerUserID,
              reason: 'MOVEMENT',
              tipoMov: 'INGRESO',
              tipoSaldo: category_service_id,
              monto: amount,
              ...extraData,
              saldoServicio: {
                prev: prevWalletUser.saldoServicio,
                result: actualWalletUser.saldoServicio
              },
              saldoPaqueteria: {
                prev: prevWalletUser.saldoPaqueteria,
                result: actualWalletUser.saldoPaqueteria
              },
              saldoRecarga: {
                prev: prevWalletUser.saldoRecarga,
                result: actualWalletUser.saldoRecarga
              }
            });

            if (successSnackbar) enqueueSnackbar('Operacion exitosa', { variant: 'success' });
            setLoadingWalletEvent(false);

            successFuncts?.map((func) => func());
            // successFunctsParams?.map((func) => func); this is useless, isn't it?

            return res;
          })
          .catch((error) => {
            console.error(error);
            enqueueSnackbar('Se ha producido un error', { variant: 'error' });
            setLoadingWalletEvent(false);
          });
      }
      if (nameEvent === 'SUBSTRACT') {
        if (prevWalletUser[getSaldoType(category_service_id)] - amount >= 0) {
          cobrar(amount, ownerUserID, category_service_id)
            .then(async () => {
              const actualWalletUser = await getWalletUser(ownerUserID);
              await firestore.collection('transactionUsers').add({
                amount,
                increase: false,
                user_id: ownerUserID,
                categoryService: category_service_id,
                previousBalance: prevWalletUser[getSaldoType(category_service_id)],
                laterBalance: actualWalletUser[getSaldoType(category_service_id)],
                payment_method,
                payment_source,
                message: message || 'Sin mensaje',
                reason,
                rerport_id,
                ...extraData,
                created_at: new Date(),
                updated_at: new Date()
              });

              if (reporteAction)
                await firestore
                  .collection('payment_reports')
                  .doc(rerport_id)
                  .update({
                    status: 'CANCELADO',
                    cancel_message: message || 'Sin mensaje',
                    cancel_at: new Date(),
                    updated_at: new Date()
                  });

              const res = await firestore.collection('walletEvents').add({
                date: new Date(),
                initWallet: false,
                user_id: ownerUserID,
                reason: 'MOVEMENT',
                tipoMov: 'EGRESO',
                tipoSaldo: category_service_id,
                monto: amount,
                ...extraData,
                saldoServicio: {
                  prev: prevWalletUser.saldoServicio,
                  result: actualWalletUser.saldoServicio
                },
                saldoPaqueteria: {
                  prev: prevWalletUser.saldoPaqueteria,
                  result: actualWalletUser.saldoPaqueteria
                },
                saldoRecarga: {
                  prev: prevWalletUser.saldoRecarga,
                  result: actualWalletUser.saldoRecarga
                }
              });

              if (successSnackbar) enqueueSnackbar('Operacion exitosa', { variant: 'success' });
              setLoadingWalletEvent(false);
              successFuncts?.map((func) => func());

              return res;
            })
            .catch((error) => {
              console.log(error.response);
              enqueueSnackbar('Se ha producido un error', { variant: 'error' });
              setLoadingWalletEvent(false);
            });
        } else {
          enqueueSnackbar('Saldo insuficiente---', { variant: 'error' });
          setLoadingWalletEvent(false);
        }
      }
    } else {
      enqueueSnackbar('Se ha producido un error, no se pudo realizar la transaccion.', { variant: 'error' });
      setLoadingWalletEvent(false);
    }
  };
  return { handleWalletEvent, loadingWalletEvent };
}

export default useWalletEvents;
